/**
 * This function will reorder dimensions display from 'x - y - z' to 'z - x - y' as per TradeRadiator's request, without shifting the underlying data.
 */
export var reorderDimensionsDisplayText = function (name) {
    var dimsArray = name.split(' x ');
    if (dimsArray.length === 3) {
        var heightDim = dimsArray.pop();
        if (heightDim) {
            dimsArray.unshift(heightDim);
            return dimsArray.join(' x ');
        }
        else {
            return name;
        }
    }
    return name;
};
